/* eslint-disable no-param-reassign */

import { createAsyncThunk, createSlice, SerializedError } from '@reduxjs/toolkit'
import { PlacementResponse, getPlacement } from '../api/registration'
import { RootState } from './rootReducer'

interface State {
  placement: PlacementResponse | null
  loading: 'idle' | 'pending'
  error: SerializedError | null
}

const initialState: State = {
  placement: null,
  loading: 'idle',
  error: null,
}

export const fetchPlacement = createAsyncThunk<
  PlacementResponse,
  string,
  {
    state: RootState
  }
>('placement/fetchPlacement', async (id) => {
  const response = await getPlacement(id)
  return response.data
})

const slice = createSlice({
  name: 'placement',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    /*
     * fetchPlacement
     */
    builder.addCase(fetchPlacement.pending, (state) => {
      state.placement = null
      state.error = null
      state.loading = 'pending'
    })
    builder.addCase(fetchPlacement.fulfilled, (state, { payload }) => {
      state.placement = payload
      state.loading = 'idle'
    })
    builder.addCase(fetchPlacement.rejected, (state, action) => {
      state.error = action.error
      state.loading = 'idle'
    })
  },
})

// export const { } = slice.actions

export default slice.reducer
